/**
 * Datos de contacto e identidad del sitio.
 * Fuente única: cualquier cambio de correo, teléfono o redes se hace aquí.
 * Debe mantenerse sincronizado con los datos estructurados de `index.html`
 * y `public/ai-metadata.json`, que no pueden importar este módulo.
 */

const phoneRaw = '573207386054'

export const SITE = {
  name: 'Florez Jaramillo',
  legalName: 'Florez Jaramillo Solutions',
  tagline: 'Soluciones Tecnológicas',
  url: 'https://florezjaramillo.com',
  contact: {
    email: 'info@florezjaramillo.com',
    emailHref: 'mailto:info@florezjaramillo.com',
    phone: '+57 320 738 6054',
    phoneHref: `tel:+${phoneRaw}`,
    whatsapp: `https://wa.me/${phoneRaw}`,
    location: 'Bogotá, Colombia'
  },
  social: {
    github: 'https://github.com/florezjaramillo',
    instagram: 'https://www.instagram.com/florezjaramillosolutions',
    twitter: 'https://twitter.com/florezjaramillo'
  }
} as const

/** Construye un mailto con asunto pre-rellenado. */
export const mailto = (subject?: string) => (subject ? `${SITE.contact.emailHref}?subject=${encodeURIComponent(subject)}` : SITE.contact.emailHref)

/** Construye un enlace de WhatsApp con mensaje pre-rellenado. */
export const whatsapp = (message?: string) => (message ? `${SITE.contact.whatsapp}?text=${encodeURIComponent(message)}` : SITE.contact.whatsapp)
